/**
 * LMJE CTA Click Tracking — lmje-cta-tracking.js
 *
 * Fires a GA4 'cta_click' event on any element with [data-cta-location].
 * Uses beacon transport so the hit survives page navigation.
 *
 * Manual step for Lara (GA4 dashboard, not code):
 *   1. Admin > Events > mark 'cta_click' as a Key Event (star it).
 *   2. Explore > Free-form: dimension = cta_location, metric = Key events.
 */
document.addEventListener('click', function (e) {
  var el = e.target.closest('[data-cta-location]');
  if (!el) return;
  if (window.gtag) {
    gtag('event', 'cta_click', {
      cta_location: el.getAttribute('data-cta-location'),
      link_url: el.getAttribute('href'),
      transport_type: 'beacon'
    });
  }
});
